import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Pomodoro from './Components/Pomodoro/Pomodoro'


ReactDOM.render(<Pomodoro />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js